import { MappedClass, MappedPropertyArray, MappedPropertyDate } from '@h5s/util-object';

import { DateTime } from 'luxon';
import { CustomerInfoWithoutInvoicedCityTax } from './customer-info-without-invoiced-city-tax';

@MappedClass()
export class CityTaxCheckInformation {
  @MappedPropertyArray(() => CustomerInfoWithoutInvoicedCityTax)
  customerInfoWithoutInvoicedCityTax: CustomerInfoWithoutInvoicedCityTax[];

  @MappedPropertyDate()
  uncoveredDaysForCityTaxDefinition: DateTime[];

  constructor(init?: Partial<CityTaxCheckInformation>) {
    Object.assign(this, init);
  }
}
